import React from 'react';
import { Drawer } from "components/";

export const drawered = (WrappedComponent: typeof React.Component) => {
    class Wrapper extends React.Component {
      public render() {
        return (
          <Drawer>
            <WrappedComponent {...this.props}/>
          </Drawer>
        );
      }
    }
    return Wrapper;
};



// WEBPACK FOOTER //
// ./src/utils/Drawered.tsx